import ApplicationController from '../application_controller'

class GlobalPaymentTypesController extends ApplicationController {
  static targets = ['form']

  click () {
    this.formTarget.submit()
  }
}

export default GlobalPaymentTypesController
